<template>
  <v-app>

    <v-content>
      <router-view> </router-view>
    </v-content>
  </v-app>
</template>

<script>
import './index.sass';
export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>

<style>
  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input[type=number] {
      -moz-appearance:textfield;
  }
</style>